/* Hanwu 2.4: Shopify owns the OTP screen and all credentials.
 * After an official sheet closes, check the real same-origin Liquid session.
 * A close event is NOT authentication success; no email, code, password or token
 * is read, logged or stored by this module. No shadow-DOM inspection or emulation.
 */
(() => {
  'use strict';
  const bound = new WeakSet();
  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
  function localURL(path) {
    if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return null;
    try {
      const url = new URL(path, window.location.origin);
      return url.origin === window.location.origin && !url.username && !url.password ? url : null;
    } catch (_) { return null; }
  }
  function bind(root = document) {
    root.querySelectorAll('[data-hw24-auth]').forEach(panel => {
      if (bound.has(panel)) return;
      bound.add(panel);
      const component = panel.querySelector('[data-hw24-component]');
      const message = panel.querySelector('[data-hw24-status]');
      const hub = localURL(panel.dataset.memberHub);
      const endpoint = localURL(panel.dataset.sessionCheck);
      if (!component || !hub || !endpoint || endpoint.searchParams.get('view') !== 'member-auth-check') return;
      let opened = false;
      let checking = false;
      const say = value => { if (message) message.textContent = value; };
      component.addEventListener('open', () => {
        opened = true;
        say('请在官方验证面板内完成邮箱验证。关闭面板本身不会登录。');
      });
      component.addEventListener('close', async () => {
        if (!opened || checking) return;
        opened = false; checking = true;
        say('正在向本站确认账号登录状态…');
        try {
          for (const delay of [0, 650, 1350]) {
            if (delay) await wait(delay);
            if (!panel.isConnected) return;
            const url = new URL(endpoint.href);
            url.searchParams.set('_hw', String(Date.now()));
            const abort = new AbortController();
            const timeout = setTimeout(() => abort.abort(), 4000);
            try {
              const response = await fetch(url.href, {
                method: 'GET', credentials: 'same-origin', cache: 'no-store',
                redirect: 'error', signal: abort.signal, headers: {Accept: 'application/json'}
              });
              if (!response.ok) throw new Error('session-check-unavailable');
              const text = await response.text();
              if (text.length > 512) throw new Error('invalid-session-response');
              const result = JSON.parse(text);
              if (result.hanwu_auth_check !== 1 || typeof result.authenticated !== 'boolean') throw new Error('invalid-session-response');
              if (result.authenticated === true) {
                say('本站已确认登录，正在打开独立会员中心…');
                window.location.assign(hub.href);
                return;
              }
            } finally { clearTimeout(timeout); }
          }
          say('本站尚未确认登录。可重新打开安全验证，或点击上方会员中心检查。');
        } catch (_) {
          say('暂时无法读取登录状态。完成官方验证后，请点击上方「打开会员中心」。');
        } finally { checking = false; }
      });
    });
  }
  document.addEventListener('shopify:section:load', e => bind(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(), {once: true});
  else bind();
})();
